import template from "./scenes.html";
import controller from "./scenes.controller";
import "./scenes.scss";

const ScenesComponent = {
    template,
    controller,
    controllerAs: "ctrl",
    bindings: {
        model: "=",
        general: "<",
        liveView: "=",
        company: "<",
        single: "<",
        gif: "<",
        boomerang: "<",
        video: "<",
        hidePhotoBg: "<",
        callback: "&",
        unscreenIsActive: "<",
        isPortraite: "<",
        isRemoveBgIsActive: "=",
        disabled: "<",
        newDesign: "<",
        activeFeatures: "<",
        activeModes: "<",
        promptingEnabled: "<",
        promptingQuality: "<"
    }
};

export default ScenesComponent;



// WEBPACK FOOTER //
// ./sources/components/configurations/scenes/scenes.component.js